import { Text } from '@chakra-ui/react';
import BulletButton from './index';
import BulletModal from '../Modal';

const Label = ({ option, props, jobSeekerData }) => {

  const stateProps = props.stateProps;
  const labels = option.label.split('~');
  const capitalizeLabel = (labelPart) => {
    if (labelPart !== '') {

      const firstLetter = labelPart[0].toUpperCase();
      const remainder = labelPart.slice(1);
      return firstLetter + remainder;
    } else {
      return labelPart;
    }
  };
  if (labels.length > 0) {
    return labels.map((labelPart, index) => {
      return (
        <>
          <Text as="span" sx={{ padding: 0, margin: 0 }}>
            {capitalizeLabel(labelPart)}
            {index < labels.length - 1 && (
              <BulletButton jobSeekerData={jobSeekerData} stateProps={stateProps} option={option} index={index}
                            labelPart={labelPart} />
            )}
          </Text>
          {index < labels.length - 1 && (
            <BulletModal jobSeekerData={jobSeekerData} props={props} option={option} />
          )}
        </>
      );
    });
  }
};

export default Label;
